import Form from "../home-emprunteur/components/Form";
import Architect from "../../assets/architect.jpg";
import PageWrapper from "../../components/ui/wrappers/PageWrapper";
import Seo from "../../components/Seo";

const RegisterEmprunteur = () => {
    return <PageWrapper>
        <Seo
            title="Inscription emprunteur"
            description="Inscrivez-vous en tant qu'emprunteur sur PretUp et lancez votre demande de financement. Accedez aux etapes cles et preparez votre dossier."
        />
        <h2 className="mb-12 base-h2-primary">PretUp, expert du pret participatif aux PME</h2>
        <div className="mb-12 flex gap-20">
            <div className="mb-12 text-gray-600">
                <p className="mb-10 text-xl text-black mt-4">Enfin une maniere simple d'obtenir un credit entreprise pour financer votre activite</p>
                <p>Nous vous accompagnons dans l'ensemble de vos projets de financement : financement de croissance, BFR, stocks, investissements, materiels, logiciels, recrutement, reprise LBO.</p>
                <p>Deposez votre demande de financement en quelques clics depuis ce formulaire. Retour de la pre eligibilite sous 48h par nos experts en credit.</p>
            </div>
            <img src={Architect} className="w-1/2 max-w-md rounded-lg" alt="Pret participatif aux PME" />
        </div>
        <Form className="mb-12 rounded-lg" formClass="mt-4 bg-gray-100 px-12 py-6 rounded-lg" />
    </PageWrapper>;
};

export default RegisterEmprunteur;
